import { render, staticRenderFns } from "./djgjb.vue?vue&type=template&id=3cdca14e&scoped=true"
import script from "./djgjb.vue?vue&type=script&lang=js"
export * from "./djgjb.vue?vue&type=script&lang=js"
import style0 from "./djgjb.vue?vue&type=style&index=0&id=3cdca14e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdca14e",
  null
  
)

export default component.exports